<div class="team-main-container analytics-wrap no-margins no-padding">
  <div [ngClass]="{ 'justify-content-between': product }"
       class="step-header flex align-items-baseline no-margins">
    <h2 class="no-margins">Analytics</h2>

    @if(product)
    {
      <div class="text-right w-8">
        <h3 class="text-ellipsis">{{ product.businessName }}</h3>
        <p class="no-margins">
          {{ getBusinessTypeValue(product?.businessType ? product.businessType : '' )}}
        </p>
      </div>
    }
  </div>

  <div class="step-body mt-15">
    <div class="flex w-full justify-content-center">
      <p-datepicker [(ngModel)]="range" class="w-75" inputStyleClass="w-full" selectionMode="range" [showIcon]="true" [readonlyInput]="true" tabindex="-2" />
    </div>
    
    @if(chartTabs().length)
    {
      <ul class="analytics-tabs flex justify-content-evenly">
        @for(tab of chartTabs(); track $index)
        {
          <li (click)="selectChartTab($index, tab)"
            [ngClass]="{ 'active-tab': tab.active }"
            [autofocus]="tab.active"
            class="pointer">
            {{ tab.name | splitCamelCase }}
        </li>
        }
        
      </ul>
    }

    @if(chartData)
    {
      <div class="chart-wrap">
        <p-chart [data]="chartData" [options]="chartOptions" type="bar"></p-chart>
      </div>
    }

    @if(chartData?.datasets?.length)
    {
      <div class="chart-description text-center mt-10">
        {{ chartData.datasets[0].label === chartDataModel.VideoViewed
            ? 'Seconds viewed'
            : '' }}
      </div>
    }
  </div>
</div>
